import styled from 'styled-components'

export const StyledCustomSection = styled.div<{ isNotBottomPadding?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: ${props => (props.isNotBottomPadding ? 0 : props.theme.spacing.large)};
  padding: ${props => props.theme.spacing.large};
  border-radius: 1rem;
  background: linear-gradient(253.87deg, #fff6f1 -4.3%, #d2d2ff 318.65%);
  height: 98px;
`

export const StyledCustomSectionBg = styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0;
  width: auto;
  height: 98px;

  img {
    width: auto;
    height: 100%;
  }
`

export const StyledCustomSectionContent = styled.div`
  div {
    font-size: 16px;
    margin-bottom: ${props => props.theme.spacing.medium};
  }

  button {
    padding: 0;
    background-color: transparent;
    font-weight: 500;
    color: rgba(85, 88, 255, 1);
    font-size: 18px;
    display: flex;
    align-items: center;
  }
`

export const StyledCustomSectionIcon = styled.div`
  position: relative;
  z-index: 2;

  img {
    width: auto;
    height: 80px;
  }
`
